import React from 'react';
import { TabPanel } from '../components/TabPanel';
import { KillerQuestionsSummary } from 'components/KillerQuestionsEditor/KillerQuestionsSummary';
import { MotiviewKillerQuestion } from 'typings/target_group';

interface KillerQuestionsTabProps {
    tab: string;
    index: number;
    selectedIndex: number;

    questions: MotiviewKillerQuestion[];
    minCorrect: number;
    redirectUrl: string;
}

/**
 * The questions a candidate answers before registering.
 *
 * Read only, and so has no save button: the backend copies these from the
 * stored group on update and ignores whatever the request carries, so there is
 * nothing here that could be saved.
 */
export const KillerQuestionsTab = ({
    tab,
    index,
    selectedIndex,
    questions,
    minCorrect,
    redirectUrl,
}: KillerQuestionsTabProps) => (
    <TabPanel tab={tab} index={index} selectedIndex={selectedIndex}>
        <KillerQuestionsSummary
            questions={questions}
            minCorrect={minCorrect}
            redirectUrl={redirectUrl}
        />
    </TabPanel>
);

export default KillerQuestionsTab;
